import { Maximize } from 'lucide-react';
import React from 'react';
import { Button } from '@components/ui/button';

interface FullscreenButtonProps {
    onClick: () => void;
}

export function FullscreenButton({ onClick }: FullscreenButtonProps) {
    return (
        <Button
            variant="outline"
            size="icon"
            onClick={onClick}
            title="Enter Fullscreen"
            className="absolute top-0 right-0 z-10 text-primary"
        >
            <Maximize />
        </Button>
    );
}
